<div class="main-container">
    <div class="header-container">
        <p i18n="@@CancelRequest" t="CancelRequest">Cancel Request</p>
    </div>
    <div class="form">
        <form [formGroup]="form">
            <tsl-form-field class="w-100">
                <tsl-label i18n="@@PleaseProvideTheReasonForCancellation" t="PleaseProvideTheReasonForCancellation">Please provide details on why you are cancelling this request.</tsl-label>
                <textarea tslInput fullWidth shape="rectangle" formControlName="Comment" maxlength="200"></textarea>
                <tsl-hint align="below" class="max-length-hint">
                    {{ commentControl.value?.length || 0 }} / 200
                </tsl-hint>
                <tsl-error *ngIf="commentControl.errors && (commentControl.dirty || commentControl.touched)">
                    <span i18n="@@PleaseProvideReason" t="PleaseProvideReason">Please provide reason</span>
                </tsl-error>
            </tsl-form-field>
        </form>
    </div>
    <div class="button-container">
        <button class="action-btn" tsl-button size="small" color="black" unfilled (click)="onClose()"
            i18n="@@Cancel" t="Cancel">Cancel</button>
        <button class="action-btn" tsl-button size="small" color="blue" filled (click)="onSubmit()"
            i18n="@@Submit" t="Submit">Submit</button>
    </div>
</div>